// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/SocialShare.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/SocialShare.tsx");
  import.meta.hot.lastModified = "1732036225891.7903";
}
// REMIX HMR END

import { useLocation } from "@remix-run/react";
import IconResolver from "~/components/IconResolver";
import Link from "~/components/Link";
import clsx from "clsx";
const socialMediaLinks = [{
  token: "twitter",
  href: "https://twitter.com/intent/tweet/?text=REPLACE_TEXT&url=REPLACE_URL"
}, {
  token: "linkedin",
  href: "https://www.linkedin.com/sharing/share-offsite/?url=REPLACE_URL"
}, {
  token: "facebook",
  href: "https://facebook.com/sharer/sharer.php?u=REPLACE_URL"
}];
const variant = {
  primary: "justify-center items-center",
  secondary: "justify-start items-start"
};
export default function SocialShare({
  alignment
}) {
  _s();
  const {
    pathname
  } = useLocation();
  const URL = `https://octahedroid.com${pathname}`;
  return <section className={clsx("flex py-4 my-4 md:py-8 md:my-8 border-y border-neutral-400 w-full flex-col", variant[alignment])}>
      <p className="text-xl font-semibold text-primary-700">Share with others</p>
      <div className={clsx("flex gap-6 w-full pt-3", variant[alignment])}>
        {socialMediaLinks.map(link => {
        const to = link.href.replace("REPLACE_URL", encodeURIComponent(URL)).replace("REPLACE_TEXT", encodeURIComponent("Octahedroid"));
        return <Link key={link.token} to={to} className="flex items-center justify-center w-[24px] aspect-square !text-neutral-500 !mr-0 hover:!text-neutral-400" target="_blank" rel="noopener" aria-label={`Share on ${link.token}`}>
              <IconResolver token={link.token} />
            </Link>;
      })}
        <button type="button" onClick={() => navigator.clipboard.writeText(URL)}>
          <IconResolver token="duplicate" className="flex items-center justify-center w-[24px] aspect-square !text-neutral-500 hover:!text-neutral-400" />
        </button>
      </div>
    </section>;
}
_s(SocialShare, "qVMqkCpYCjknUqSjfMln5RFSkbo=", false, function () {
  return [useLocation];
});
_c = SocialShare;
var _c;
$RefreshReg$(_c, "SocialShare");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;